// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSE_MENU';
export const WINDOW_WIDTH = 'WINDOW-WIDTH';
export const SWITCH_LANGUAGE = 'SWITCH-LANGUAGE';
export const CHANGE_LANGUAGE = 'CHANGE-LANGUAGE';
export const SET_CURRENCY_DATA = 'SET-CURRENCY-DATA';
export const SET_PREFERRED_CURRENCY = 'SET-PREFERRED-CURRENCY';
export const SET_DEFAULT_CURRENCY_OBJ = 'SET-DEFAULT-CURRENCY-OBJ';

//Contact Module const
export const FETCH_START = 'fetch_start';
export const FETCH_SUCCESS = 'fetch_success';
export const FETCH_ERROR = 'fetch_error';
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const ON_SHOW_LOADER = 'ON_SHOW_LOADER';
export const ON_HIDE_LOADER = 'ON_HIDE_LOADER';

//Auth const
export const SIGNUP_USER = 'SIGNUP_USER';
export const SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS';
export const SIGNIN_GOOGLE_USER = 'SIGNIN_GOOGLE_USER';
export const SIGNIN_GOOGLE_USER_SUCCESS = 'SIGNIN_GOOGLE_USER_SUCCESS';
export const SIGNIN_FACEBOOK_USER = 'SIGNIN_FACEBOOK_USER';
export const SIGNIN_FACEBOOK_USER_SUCCESS = 'SIGNIN_FACEBOOK_USER_SUCCESS';
export const SIGNIN_TWITTER_USER = 'SIGNIN_TWITTER_USER';
export const SIGNIN_TWITTER_USER_SUCCESS = 'SIGNIN_TWITTER_USER_SUCCESS';
export const SIGNIN_GITHUB_USER = 'SIGNIN_GITHUB_USER';
export const SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_success';
export const SIGNIN_USER = 'SIGNIN_USER';
export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS';
export const SIGNOUT_USER = 'SIGNOUT_USER';
export const SIGNOUT_USER_SUCCESS = 'SIGNOUT_USER_SUCCESS';
export const INIT_URL = 'INIT_URL';
export const USER_DATA = 'user_data';
export const CURRENT_PAGE_DATA = 'CURRENT_PAGE_DATA';
export const USER_TOKEN_SET = 'user_token_set';
export const USER_DEFAULT_PASSWORD_SET = 'user_default_password_set';

export const LIST_DATA = "list_data";
export const CATCH_MASTER_DATA = "catch_master_data"
export const TOKEN_KEY = 'EScooterAuthToken';

//Franchisee list data
export const FRANCHISEE_LIST = 'FRANCHISEE_LIST';
export const DEALER_LIST = 'DEALER_LIST';
export const FRANCHISEE_NAME = 'FRANCHISEE_NAME';
export const DEALER_NAME = 'DEALER_NAME';
// export const FRANCHISEE_LIST_LENGTH = 'FRANCHISEE_LIST_LENGTH';
export const IS_SOCKET_CONNECTED = 'IS_SOCKET_CONNECTED';
export const SET_SOCKET = 'SET_SOCKET';
export const MAP_CENTER = 'MAP_CENTER';

